import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import apiMethod from "../../../services/api-service";
import methods from "../../../services/utility";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";

const EditModalAddress = ({ show, onHide, setLoading, getAdress, id }) => {
  const { branchId } = useParams();
  const [shipments, setShipments] = useState([]);
  const [shipmentsInfo, setShipmentsInfo] = useState({
    branchId,
    title: "",
    size: 200,
    part: 1,
  });
  const [addressInfo, setAddressInfo] = useState({
    id: 0,
    title: "",
    address: "",
    phone: "",
    zipCode: "",
    faxNumber: "",
    cityId: 0,
    userId: 0,
    shipmentId: 0,
  });

  const getAddressInfo = async () => {
    const resp = await apiMethod.getAddressInfo(id);
    if (methods.showApiErrors(resp)) {
      setAddressInfo({
        ...addressInfo,
        id: resp.data.id,
        title: resp.data.title,
        address: resp.data.address,
        phone: resp.data.phone,
        zipCode: resp.data.zipCode,
        faxNumber: resp.data.faxNumber,
        cityId: resp.data.cityId,
        userId: resp.data.userId,
        shipmentId: resp.data.shipmentId,
      });
    }
  };

  const getShipments = async () => {
    const resp = await apiMethod.getShipmentCosts(
      shipmentsInfo.branchId,
      shipmentsInfo.title,
      shipmentsInfo.size,
      shipmentsInfo.part
    );
    if (methods.showApiErrors(resp)) {
      setShipments(resp.data);
    }
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getAddressInfo();
      await getShipments();
      setLoading(false);
    };
    bindData();
  }, [id]);

  const handleAddressSave = async () => {
    setLoading(true);
    const resp = await apiMethod.createAddress(addressInfo);
    if (methods.showApiErrors(resp)) {
      toast.success("آدرس با موفقیت تغییر کرد");
    }
    setLoading(false);
    await getAdress();
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="md"
      backdrop={true}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="kitchen-modal"
    >
      <Modal.Header closeButton>
        <span className="fw-bold">آدرس مشتری</span>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex flex-column gap-3">
          <div className="col-12 mb-3">
            <label htmlFor="location" className="form-label">
              انتخاب محل
            </label>
            <select
              className="form-select"
              aria-label="Default select example"
              value={addressInfo?.shipmentId}
              onChange={(e) => {
                const value = e.target.value;
                setAddressInfo({
                  ...addressInfo,
                  shipmentId: value === "" ? null : Number(value),
                });
              }}
            >
              <option value={""}>محل آدرس</option>
              {shipments.map((shipment, sindx) => (
                <option key={sindx} value={shipment.id}>
                  {shipment.areaTitle} -{" "}
                  {methods.addNumSeperator(shipment.price)}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-12">
            <label htmlFor="title" className="form-label required-label">
              عنوان آدرس
            </label>
            <input
              type="text"
              id="title"
              className="form-control"
              value={addressInfo.title}
              onChange={(e) =>
                setAddressInfo({ ...addressInfo, title: e.target.value })
              }
            />
          </div>
          <div className="col-md-12">
            <label htmlFor="address" className="form-label required-label">
              آدرس
            </label>
            <textarea
              type="text"
              id="address"
              rows={4}
              className="form-control"
              value={addressInfo.address}
              onChange={(e) =>
                setAddressInfo({ ...addressInfo, address: e.target.value })
              }
            ></textarea>
          </div>
          <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
            <button
              type="button"
              className="btn custome-btn btn-link-purple"
              onClick={onHide}
            >
              انصراف
            </button>
            <button
              type="button"
              className="btn custome-btn btn-purple"
              onClick={handleAddressSave}
            >
              ثبت و ذخیره
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default EditModalAddress;
